import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { variables } from './Component/Variables';

// Pages
import Home from './Component/Home';
import News_Page from './Component/News_Page';
import TrendingNews from './Component/TrendingNews';
import Football from './Component/Football';
import BasketBall from './Component/BasketBall';
import Cricket from './Component/Cricket';
import Tennis from './Component/Tennis';
import Boxing from './Component/Boxing';
import UFC from './Component/UFC';
import Racing from './Component/Racing';
import MostViwed from './Component/MostViwed';
import FeatureNews_Home from './Component/FeatureNews_Home';
import OurLatest_News from './Component/OurLatest_News';
import FootBall_MostViewed from './Component/FootBall_MostViewed';
import BasketballHome from './Component/BasketballHome';
import CricketHome from './Component/CricketHome';
import WhatsnewHome from './Component/WhatsnewHome';
import TennisHome from './Component/TennisHome';
import UFCHome from './Component/UFCHome';
import BoxingHome from './Component/BoxingHome';
import TrendingNewsMain from './Component/TrendingNewsMain';
import TennisMain from './Component/TennisMain';
import SearchBar from './Component/SearchBar';
import AthletixContactUs from './Component/AthletixContactUs';
import AthletixAdvertise from './Component/AthletixAdvertise';
import AthletixPrivacy from './Component/AthletixPrivacy';
import AthletixAbout from './Component/AthletixAbout';
import AllResultMatcehs from './Component/AllResultMatcehs';
import MatchHomePage from './Component/MatchHomePage';
import TennisMatches from './Component/TennisMatches';
import FootballMatches from './Component/FootballMatches';

function FastRedirect() {
  const { storyID, title } = useParams();
  return <Navigate to={`/${storyID}/${title}`} replace />;
}

export default function App() {
  return (
    <div className="App">
      <Routes>

        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Pages */}
        <Route path="/Football" element={<Football />} />
        <Route path="/BasketBall" element={<BasketBall />} />
        <Route path="/Cricket" element={<Cricket />} />
        <Route path="/Tennis" element={<Tennis />} />
        <Route path="/Boxing" element={<Boxing />} />
        <Route path="/UFC" element={<UFC />} />
        <Route path="/Racing" element={<Racing />} />
        <Route path="/MostViwed" element={<MostViwed />} />
        <Route path="/FeatureNews_Home" element={<FeatureNews_Home />} />
        <Route path="/OurLatest_News" element={<OurLatest_News />} />
        <Route path="/FootBall_MostViewed" element={<FootBall_MostViewed />} />

        {/* Home Subcomponents */}
        <Route path="/BasketballHome" element={<BasketballHome />} />
        <Route path="/CricketHome" element={<CricketHome />} />
        <Route path="/WhatsnewHome" element={<WhatsnewHome />} />
        <Route path="/TennisHome" element={<TennisHome />} />
        <Route path="/UFCHome" element={<UFCHome />} />
        <Route path="/BoxingHome" element={<BoxingHome />} />
        <Route path="/TrendingNewsMain" element={<TrendingNewsMain />} />
        <Route path="/TennisMain" element={<TennisMain />} />

        {/* Other Pages */}
        <Route path="/SearchBar" element={<SearchBar />} />
        <Route path="/AthletixContactUs" element={<AthletixContactUs />} />
        <Route path="/AthletixAdvertise" element={<AthletixAdvertise />} />
        <Route path="/AthletixPrivacy" element={<AthletixPrivacy />} />
        <Route path="/AthletixAbout" element={<AthletixAbout />} />
        <Route path="/AllResultMatcehs" element={<AllResultMatcehs />} />
        <Route path="/MatchHomePage" element={<MatchHomePage />} />
        <Route path="/TennisMatches" element={<TennisMatches />} />
        <Route path="/FootballMatches" element={<FootballMatches />} />

        {/* TrendingNews */}
        <Route path="/TrendingNews" element={<TrendingNews />} />

        {/* =============================== */}
        {/* News Page Dynamic Routes (MOVED HERE) */}
        {/* =============================== */}

        <Route 
          path="/:storyID/:title" 
          element={<News_Page />} 
        />

        <Route 
          path="/news_page/:storyID/:title" 
          element={<News_Page />} 
        />

        <Route 
          path={variables.basename + "/:storyID/:title"} 
          element={<News_Page />} 
        />

        <Route 
          path={variables.basename + "/news_page/:storyID/:title"} 
          element={<News_Page />} 
        />

        {/* Catch-all (ALWAYS LAST) */}
        <Route path="*" element={<Home />} />

      </Routes>
    </div>
  );
}